import React from 'react';
import PortraitPaperLayout from '../@common/portrait/PortraitPaperLayout';
import GridWithText from '../@common/GridWithText';
import { WorksheetBaseProps } from '../@types';

type WordCardProps = WorksheetBaseProps & {
  value: string;
  isCursive?: boolean;
  isNarrow?: boolean;
};

const WordCards = ({ onChange, isCursive, isNarrow, valueMap, printRef }: WordCardProps) => {
  const handleChange = (key, value) => {
    onChange({
      [key]: value
    });
  };
  return (
    <PortraitPaperLayout isNarrow={isNarrow} printRef={printRef}>
      <GridWithText
        showLineToggle
        numOfCols={3}
        numOfRows={9}
        handleChange={handleChange}
        valueMap={valueMap}
        isCursive={isCursive}
        isNarrow={isNarrow}
      />
    </PortraitPaperLayout>
  );
};

export default WordCards;
